import React, { CSSProperties } from "react";

import { TableCell } from "semantic-ui-react";

type TableTotalSlotsCellProps = {
  style?: CSSProperties;
  cellStyle?: CSSProperties;
  colSpan: number;
  groupedEvents: {
    color_code: string;
    title: string;
    total: number;
  }[];
  remainingCells: number;
  totalSlots: number;
};

const TableTotalSlotsCell = (props: TableTotalSlotsCellProps) => (
  <>
    <TableCell
      style={{ left: 0, position: "sticky", zIndex: 1, ...props.cellStyle }}
      colSpan={props.colSpan}
    >
      <div>
        <div className="events-list" style={{ opacity: 0, ...props.style }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              rowGap: "0.25rem",
            }}
          >
            {props.groupedEvents.map((item, index) => (
              <div key={`group-event${index}`} style={{ alignItems: "center", display: "flex" }}>
                <label>{item.title}</label>
                <div className="summary-badge" style={{ backgroundColor: item.color_code }}>
                  {item.total}
                </div>
              </div>
            ))}
          </div>
          <div style={{ flex: 1 }} />
          <div>
            Total Slot:{" "}
            <strong>
              <span style={{ fontSize: "1rem", paddingRight: "0.25rem" }}>{props.totalSlots}</span>
            </strong>
          </div>
        </div>
      </div>
    </TableCell>
    {Array.from({ length: props.remainingCells }, (unused, index) => (
      <TableCell key={`total-slot-${index}`} style={props.cellStyle} />
    ))}
  </>
);

TableTotalSlotsCell.displayName = "TableTotalSlotsCell";

export default React.memo(TableTotalSlotsCell);
